//这里是 统计报表 模块的路由文件

const basePath = "/admin/stat/";

/**
 *
 * @param {string} path 路由名称
 * @returns {string}
 */
const makePath = (path) => `${basePath}${path}`;

export default [
  {
    // 财务费用列表
    path: makePath("financial"),
    name: "stat-financial",
    component: (r) => require.ensure([], () => r(require("@/views/statistics/Financial.vue")), "statistics"),
  },
  {
    // 客户请求统计表
    path: makePath("customer"),
    name: "stat-customer",
    component: (r) => require.ensure([], () => r(require("@/views/statistics/Customer.vue")), "statistics"),
  },
  {
    // 外勤工程师报表
    path: makePath("engineer"),
    name: "stat-engineer",
    component: (r) => require.ensure([], () => r(require("@/views/statistics/Engineer.vue")), "statistics"),
  },
  {
    // 統計报表
    path: makePath("view"),
    name: "stat-view",
    component: (r) => require.ensure([], () => r(require("@/views/statistics/StatView.vue")), "statistics"),
  },

];
